module.exports = __webpack_public_path__ + "img/logo-getit.f1fd8a6d.jpeg";